// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionRecordDto
 */
export interface IContributionRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    record_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    partner_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    employer_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionRecordDto
     */
    tax_type?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    tax_year?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    contribution_date?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionRecordDto
     */
    employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionRecordDto
     */
    employer_contribution_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    ee_contribution_tag?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordDto
     */
    er_contribution_tag?: string;
}

/**
 * Check if a given object implements the IContributionRecordDto interface.
 */
export function instanceOfIContributionRecordDto(value: object): value is IContributionRecordDto {
    return true;
}

export function IContributionRecordDtoFromJSON(json: any): IContributionRecordDto {
    return IContributionRecordDtoFromJSONTyped(json, false);
}

export function IContributionRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'record_type': json['record_type'] == null ? undefined : json['record_type'],
        'partner_id': json['partner_id'] == null ? undefined : json['partner_id'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_id': json['employer_id'] == null ? undefined : json['employer_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'tax_type': json['tax_type'] == null ? undefined : json['tax_type'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'contribution_date': json['contribution_date'] == null ? undefined : json['contribution_date'],
        'employee_contribution_amount': json['employee_contribution_amount'] == null ? undefined : json['employee_contribution_amount'],
        'employer_contribution_amount': json['employer_contribution_amount'] == null ? undefined : json['employer_contribution_amount'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'ee_contribution_tag': json['ee_contribution_tag'] == null ? undefined : json['ee_contribution_tag'],
        'er_contribution_tag': json['er_contribution_tag'] == null ? undefined : json['er_contribution_tag'],
    };
}

export function IContributionRecordDtoToJSON(json: any): IContributionRecordDto {
    return IContributionRecordDtoToJSONTyped(json, false);
}

export function IContributionRecordDtoToJSONTyped(value?: IContributionRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'record_type': value['record_type'],
        'partner_id': value['partner_id'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_id': value['employer_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'last_name': value['last_name'],
        'plan_code': value['plan_code'],
        'tax_type': value['tax_type'],
        'tax_year': value['tax_year'],
        'contribution_date': value['contribution_date'],
        'employee_contribution_amount': value['employee_contribution_amount'],
        'employer_contribution_amount': value['employer_contribution_amount'],
        'memo': value['memo'],
        'ee_contribution_tag': value['ee_contribution_tag'],
        'er_contribution_tag': value['er_contribution_tag'],
    };
}

